import React, { memo, useState } from 'react';
import resultCards from '../ResultCards';
import "./OptionsMenu.scss"
const OptionsMenu = ({ minBetAmt, maxBetAmt, GameRules, tableProps, tableclass, headClass, bodyClass, history, openOptions = () => { } }) => {

    const [showDivs, setShowDivs] = useState({
        ShowLimits: false,
        ShowGamerules: true,
        ShowHistory: false
    })

    return <div className="back_cover">
        <div id="allOptions">
             <div className="outerBevel">
                <div className="flatSurface">
                    <div className="innerBevel"> 
                        <div id="options_content">
                            <div id="options_exit_btn" alt="exitBtn" onClick={openOptions}>X</div>
                            <div id="btnGroup">
                                <button className={`optionsBtn ${showDivs.ShowLimits && "opt_btn_active"}`} role="button" onClick={(e) => { e.preventDefault(); !showDivs.ShowLimits && setShowDivs({ ShowLimits: true, ShowGamerules: false, ShowHistory: false }); }}>Limits</button>
                                <button className={`optionsBtn ${showDivs.ShowGamerules && "opt_btn_active"}`} role="button" onClick={(e) => { e.preventDefault(); !showDivs.ShowGamerules && setShowDivs({ ShowLimits: false, ShowGamerules: true, ShowHistory: false }); }}>Help</button>
                                <button className={`optionsBtn ${showDivs.ShowHistory && "opt_btn_active"}`} role="button" onClick={(e) => { e.preventDefault(); !showDivs.ShowHistory && setShowDivs({ ShowLimits: false, ShowGamerules: false, ShowHistory: true }); }}>History</button>
                            </div>
                            <div id="opt_content">
                                {
                                    <div id="Limits12" className={`section ${showDivs.ShowLimits ? "visible" : "hidden"}`}>
                                        <span>MinBet:{minBetAmt}</span>
                                        <span>MaxBet:{maxBetAmt}</span>
                                    </div>
                                }
                                {
                                    <div id="GameRules" className={`section ${showDivs.ShowGamerules ? "visible" : "hidden"}`}>
                                        <h1 id="gameruleMainHeading">GAME RULES</h1>
                                        <hr id="hrline" />
                                        <ul id="LibraryUnOrderedListItems">

                                            {GameRules.map((val, key) => (
                                                <li key={key}>{val.name}</li>
                                            ))}
                                        </ul>
                                    </div>
                                }
                                {
                                    <div id='gameHistory' className={`section ${showDivs.ShowHistory ? "visible" : "hidden"}`}>
                                        <table id={tableclass} style={{ visibility: showDivs.ShowHistory ? "visible" : "hidden" }}>
                                            <thead id={headClass}>
                                            <tr>
                                                {
                                                    tableProps.filter(ele => ele.isdisplay).map((ele, ind) => <th key={ind}>{ele.title}</th>)
                                                }
                                            </tr>
                                            </thead>
                                            <tbody id={bodyClass}>
                                            {history.filter((obj, i, arr) => arr.length - i <= 5).map((obj, i) => (
                                                <tr key={`card-${i}`} id={`${i}`}>
                                                    {
                                                        tableProps.filter(ele => ele.isdisplay).map((ele, ind) => {
                                                            let content;
                                                            if (ele.isShowCards) {
                                                                content = obj.result[ele.key].map((card_num, index) => {
                                                                    const matchingCard = resultCards.find(res => res.rsc_val === card_num);
                                                                    return (
                                                                        <img
                                                                            className="cardsimages"
                                                                            key={index}
                                                                            src={matchingCard ? matchingCard.src : ''}
                                                                            alt={card_num}
                                                                        />


                                                                    );
                                                                })
                                                            } else if (ele.key === "handId") {
                                                                content = obj[ele.key]
                                                            } else {
                                                                content = obj.result[ele.key] ? obj.result[ele.key] : 0
                                                            }
                                                            return <td key={ind}>{content}</td>
                                                        })
                                                    }
                                                </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
};

export default memo(OptionsMenu);